/* eslint-disable camelcase */
import { Box } from '@mui/material'
import { DateTime } from 'luxon'
import { Columns } from '../../components/atoms/Columns'
import { Port } from '../../types/models'
import { OptimizerWeatherPort, OptimizerWeatherConfig, PortConfigOptimizerWeather, WindDir, Cloudiness } from '../../types/ports'
import { lang } from '../../utils/lang'
import { DeviceControl } from '../DeviceControl'
import { PortControl } from './PortControl'
import { East, North, NorthEast, NorthWest, South, SouthEast, SouthWest, WbCloudy, WbSunny, West } from '@mui/icons-material'

const WIND_DIR_ICONS: Record<WindDir, any> = {
  N: South,
  NE: SouthWest,
  E: West,
  SE: NorthWest,
  S: North,
  SW: NorthEast,
  W: East,
  NW: SouthEast
}

const SUN_ICONS: Record<Cloudiness, any> = {
  CLOUDY: WbCloudy,
  'PARTLY CLOUDY': WbCloudy,
  SCATTERED: WbSunny,
  SUNNY: WbSunny,
}

const SUN_COLORS: Record<Cloudiness, string> = {
  CLOUDY: 'blue',
  'PARTLY CLOUDY': 'cyan',
  SCATTERED: 'cyan',
  SUNNY: 'yellow',
}
/**
 * Controller for optimizer control.
 */
export class OptimizerWeatherPortControl extends PortControl<OptimizerWeatherPort, OptimizerWeatherConfig> {

  port: OptimizerWeatherPort

  constructor(deviceControl: DeviceControl, port: Port) {
    super(deviceControl, port)
    this.port = port as OptimizerWeatherPort
  }

  get group(): string { return this.app.t('PortGroup-Optimization') }

  getTypeName(): string { return this.app.t('PortType-Optimizer Weather') }

  getDescription(): string { return this.app.t('Weather forecast') }

  getConfigDefaults(): PortConfigOptimizerWeather {
    return {
    }
  }

  infoTop() : React.ReactNode | undefined {
    const weathers = this.port.values.weathers || []
    const lines = []
    let last

    const base = DateTime.fromISO(this.port.values.base_ts).toUnixInteger()

    for (let i = 0; i < weathers.length; i++) {
      const timestamp = base + i * this.port.values.timestep
      const date = DateTime.fromMillis(timestamp * 1000)
      const day = lang.dayNameAndNumber(date)
      const time = date.toFormat('HH:mm')
      if (!last || last !== day) {
        lines.push(<Box sx={{ my: 1, color: 'primary.main' }}>{day}</Box>)
        last = day
      }
      const { sun, wind_dir, wind_speed, temperature } = weathers[i]

      const WindIcon = WIND_DIR_ICONS[wind_dir]
      const SunIcon = SUN_ICONS[sun] || <></>

      lines.push(<>{time} <SunIcon sx={{ color: SUN_COLORS[sun], width: 0.1, pt: 1.2 }}/>{wind_speed} m/s <WindIcon sx={{ width: 0.1, pt: 1.5 }}/> {temperature} °C</>)
    }

    return <Box>
      <Columns columns={3}>
        {lines.map((line, idx) => <Box key={idx}>{line}</Box>)}
      </Columns>
    </Box>
  }
}
